import React from 'react';
import Box from '@material-ui/core/Box';
import useRouter from 'use-react-router';

export const TabPanel = ({ value, index, children }) => (
  <div
    role='tabpanel'
    hidden={value !== index}
    id={`wrapped-tabpanel-${index}`}
    aria-labelledby={`wrapped-tab-${index}`}
  >
    {value === index && <Box p={3}>{children}</Box>}
  </div>
);

export function useTabs({ tabs, defaultTab }) {
  const { history } = useRouter();
  const searchParams = new URLSearchParams(history.location.search);
  const requestTab = Number(searchParams.get('tab'));
  const initTab = Object.values(tabs).includes(requestTab)
    ? requestTab
    : defaultTab;
  const [tab, setSab] = React.useState(initTab);

  const handleSetTab = (v) => {
    history.replace({
      search: `?tab=${v}`,
    });
    setSab(v);
  };
  return [tab, handleSetTab];
}
